import { jsx as _jsx } from "react/jsx-runtime";
import { getDefaultFieldValues, getPhysicalProductPricePlan, PhysicalCheckout, StoreProvider, useOfferStore, usePhysicalProductStore, } from '@systemeio/digital-store-shared';
import { ContactSlugEnum } from '@systemeio/ui';
import React from 'react';
import { CheckoutProviders } from '../hoc/checkout-providers';
import { VisitorInfoProvider } from '../hoc/visitor-info-provider';
import { useShippingRules } from '../hooks/use-shipping-rules';
export function PhysicalProductCheckoutApp({ pageWithProviders }) {
    const { locale, design, physicalProduct, ...page } = pageWithProviders;
    const selectedPaymentMethod = page.paymentMethods?.[0];
    const selectedVariant = physicalProduct?.productVariants?.[0];
    const selectedPricePlan = getPhysicalProductPricePlan(physicalProduct ?? null, selectedVariant ?? null);
    return (_jsx(StoreProvider, { initProps: {
            base: { locale },
            offer: {
                offerId: page.checkoutPage.offerId ?? undefined,
                paymentMethod: selectedPaymentMethod,
                pricePlan: selectedPricePlan ?? undefined,
                productId: physicalProduct?.id ?? undefined,
                finalAmount: selectedPricePlan?.amount,
                availablePaymentMethods: page.paymentMethods,
                currency: page.currency,
                contactFields: getDefaultFieldValues(page.checkoutPage.fields),
            },
            physicalProduct: {
                productVariant: selectedVariant,
                quantity: 1,
            },
        }, children: ({ store }) => {
            const { offer, physicalProduct: { quantity }, } = store();
            return (_jsx(VisitorInfoProvider, { children: _jsx(CheckoutProviders, { calculatePriceProps: {
                        quantity,
                        paymentMethod: offer.paymentMethod,
                        productId: offer.productId ?? null,
                        pricePlan: offer.pricePlan ?? null,
                        offer: page.checkoutPage.offerId,
                    }, design: design, offerId: page.checkoutPage.offerId, locale: locale, children: ({ calculatePrice, isLoadingCalculatePrice }) => (_jsx(PhysicalProductCheckoutProviders, { children: ({ shippingRules, isLoadingShippingRules }) => (_jsx(PhysicalCheckout, { ...page, physicalProduct: physicalProduct, shippingRules: shippingRules, calculatePrice: calculatePrice, isLoadingShippingRules: isLoadingShippingRules, isLoadingCalculatePrice: isLoadingCalculatePrice })) })) }) }));
        } }));
}
function PhysicalProductCheckoutProviders({ children }) {
    const { quantity, productVariant } = usePhysicalProductStore();
    const { productId, contactFields } = useOfferStore();
    const country = contactFields?.[ContactSlugEnum.Country]?.value;
    const { shippingRules, isLoading: isLoadingShippingRules } = useShippingRules({
        country,
        quantity,
        productVariant: productVariant?.id,
        product: productId,
    });
    return children({ shippingRules, isLoadingShippingRules });
}
